import React, { useState } from "react";
import { createTheme, ThemeProvider, styled } from "@mui/material/styles";
import DashboardIcon from "@mui/icons-material/Dashboard";
import BarChartIcon from "@mui/icons-material/BarChart";
import DescriptionIcon from "@mui/icons-material/Description";
import LayersIcon from "@mui/icons-material/Layers";
import { AppProvider, Navigation, Router } from "@toolpad/core/AppProvider";
import { DashboardLayout } from "@toolpad/core/DashboardLayout";
import { PageContainer } from "@toolpad/core/PageContainer";
import { Button, Typography } from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileUploadIcon from '@mui/icons-material/FileUpload';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import SearchIcon from '@mui/icons-material/Search';
//import from Local
import LocalDashBoard from "../../LocalComponenets/masterpages/DashBoard/LocalDashBoard";
import BankDataDownload from "../../LocalComponenets/masterpages/ExportData/BankDataDownload";
import DetailDataDownload from "../../LocalComponenets/masterpages/ExportData/DetailDataDownload";
import CreditSummery from "../../LocalComponenets/masterpages/Report/CreditSummery";
import DebitSummery from "../../LocalComponenets/masterpages/Report/DebitSummery";
import MatchDataSummery from "../../LocalComponenets/masterpages/Report/MatchDataSummery";
import MPRDetails from "../../LocalComponenets/masterpages/Report/MPRDetails";
import SBIDataImport from "../../LocalComponenets/masterpages/ImportData/SBIDataImport";
import DataParser from "../../LocalComponenets/masterpages/ImportData/DebitDataImport";
import SearchData from "../../LocalComponenets/masterpages/SearchData/SearchData";




const NAVIGATION = [
  {
    kind: "header",
    title: "Main items",
  },
  {
    segment: "dashboard",
    title: "Dashboard",
    icon: <DashboardIcon />,
  },
  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Analytics",
  },
  {
    segment: "reports",
    title: "Reports",
    icon: <BarChartIcon />,
    children: [
      {
        segment: "debit",
        title: "Debit Data",
        icon: <DescriptionIcon />,
      },
      {
        segment: "credit",
        title: "Credit Data",
        icon: <DescriptionIcon />,
      },
      {
        segment: "match",
        title: "Match Data",
        icon: <DescriptionIcon />,
      },
      {
        segment: "mpr",
        title: "Monthly Progressive Report",
        icon: <DescriptionIcon />,
      },
    ],
  },
  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Import",
  },

  {
    segment: "import",
    title: "Import",
    icon: <FileDownloadIcon  />,
    children: [
      {
        segment: "importbankdata",
        title: "Bank Data(Cr) Import",
        icon: <FileDownloadIcon />,
      },
      {
        segment: "importcrisdata",
        title: "CRIS Data(Dr) Import",
        icon: <FileDownloadIcon />,
      },
    ],
  },

  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Export",
  },

  {
    segment: "export",
    title: "Export",
    icon: <FileUploadIcon />,
    children: [
      {
        segment: "bank",
        title: "Bank Data",
        icon: <FileUploadIcon />,
      },
      {
        segment: "details",
        title: "Data Details",
        icon: <FileUploadIcon />,
      },
    ],
  },
  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Search",
  },
  {
    segment: "search",
    title: "Search",
    icon: <SearchIcon />,
    children: [
      {
        segment: "tr",
        title: "Search By TR Number/Amount",
        icon: <SearchIcon />,
      },]
  },
  {
    kind: "divider",
  },
  {
    kind: "header",
    title: "Logout",
  },
  {
    segment: "Logout",
    title: "Logout",
    icon: <LogoutIcon />,
  },
];

const demoTheme = createTheme({
  palette: {
    mode: "light",
  },
  components: {
    MuiAppBar: {
      styleOverrides: {
        root: {
          ".toolpad-icon-class": {
            display: "none",
          },
        },
      },
    },
  },
});

function useDemoRouter(initialPath) {
  const [pathname, setPathname] = React.useState(initialPath);
  const router = React.useMemo(
    () => ({
      pathname,
      searchParams: new URLSearchParams(),
      navigate: (path) => setPathname(String(path)),
    }),
    [pathname]
  );

  return router;
}

export default function DashboardLayoutBasic({ window }) {
  const router = useDemoRouter("/dashboard");
  const demoWindow = window ? window() : undefined;
  const navigate = useNavigate(); // Hook to navigate programmatically

  const handleLogout = () => {
    // Clear local session data (e.g., localStorage or sessionStorage)
    localStorage.clear(); // or sessionStorage.clear(); depending on your storage choice

    // Optionally, clear any authentication state or cookies here

    // Redirect to root page '/'
    navigate("/");
  };
  // Render content based on the current pathname
  const renderContent = () => {
    switch (router.pathname) {
      case "/dashboard":
        return <LocalDashBoard />;
      case "/reports/debit":
        return <DebitSummery />;
      case "/reports/credit":
        return <CreditSummery />;
      case "/reports/match":
        return <MatchDataSummery />;
      case "/export/bank":
        return <BankDataDownload />;
      case "/export/details":
        return <DetailDataDownload />;
      case "/reports/mpr":
        return <MPRDetails />;
      case "/import/importbankdata":
        return <SBIDataImport />;
        case "/import/importcrisdata":
          return <DataParser />;

          case "/search/tr":
            return <SearchData />;

        //
      case "/Logout":
        handleLogout();
      default:
        return <div>Page Not Found</div>;
    }
  };





  return (
    <ThemeProvider theme={demoTheme}>
      <AppProvider
        navigation={NAVIGATION}
        router={router}
        window={demoWindow}
        branding={{
          title: (
            <Typography variant="h6" className="!font-bold font-sans">
              Sriyansh Computers , Gorakhpur
            </Typography>
          ),

          logo: "", // <img src="/logo.png" alt="logo" />,
        }}
      >
        <DashboardLayout>
          <PageContainer title="" breadcrumbs="">
            {renderContent()}
          </PageContainer>
        </DashboardLayout>
      </AppProvider>



     



    </ThemeProvider>

    
  );
}
